import {
    CreateMatchPlayerCommandOfMatchPlayer,
    EventVm,
    UpdateEventCommand,
} from '../../../../utils/api';
import GoalkeeperChange from './GoalkeeperChange';

interface OwnProps {
    event: UpdateEventCommand;
    lineups: CreateMatchPlayerCommandOfMatchPlayer[];
    events: EventVm[];
    homeTeamId?: number;
    updateEvent: (event: UpdateEventCommand) => void;
    clearEvent: () => void;
    deleteEvent: (event: EventVm) => void;
}

export type Props = OwnProps;

export default GoalkeeperChange;
